module.exports = __webpack_public_path__ + "img/quest_visualization_quest_completed.6de4cd49.svg";